// copied from [rhea-backend] src/modules/common/utilities/weatherHelpers.ts for now

export type WeatherType = {
    temp?: string;
    wind?: string;
    cloudiness?: string;
    precipitation?: string;
    ["wind-direction"]?: string;
};

const PRECIPITATION_PREFERENCE = ["Dry", "Drizzle", "Rain", "Heavy rain", "Hail", "Snow"];

export function getBestWeather(reports: WeatherType[]): WeatherType | undefined {
    let driestReports: WeatherType[] = [];

    for (const condition of PRECIPITATION_PREFERENCE) {
        const result = reports.filter(r => r.precipitation === condition);
        if (result.length > 0) {
            driestReports = result;
            break;
        }
    }

    // fallback to all if nothing matched precipitationOrder
    const candidates = driestReports.length > 0 ? driestReports : reports;

    return candidates.reduce(
        (best, current) => {
            const bestTemp = Number(best?.temp ?? "-999");
            const currentTemp = Number(current?.temp ?? "-999");
            return currentTemp > bestTemp ? current : best;
        },
        undefined as WeatherType | undefined,
    );
}

export function isWeatherReportValid(report: WeatherType): boolean {
    return report !== null && report !== undefined && Object.keys(report).length !== 0;
}
